import React, { useContext, createContext } from 'react';
const AuthContext = createContext({
    currentUser: {},
});
export const useAuth = () => useContext(AuthContext);
export const AuthProvider = ({ userId, children }) => {
    const parseUserId = userId ? parseInt(userId, 10) : undefined;
    return (React.createElement(AuthContext.Provider, { value: { currentUser: { userId: parseUserId } } }, children));
};
